import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetTuition, ITuition } from '../models/homepageManagementTrainingAmount.model';

const uri = '/mgmt/homepage-management/training-amount';

export const getTuition = (campusCode: string, eduStepCode: string): AxiosPromise<IGetTuition> => {
  return axios.get(`${uri}/${campusCode}/${eduStepCode}`);
};

export const createTuition = (data: ITuition): AxiosPromise => {
  console.log(data)
  return axios.post(uri, data);
};

export const updateTuition = (campusCode: string, data: ITuition): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}`, data);
};
